import { render, staticRenderFns } from "./FileSelect.vue?vue&type=template&id=04bee9e4&scoped=true"
import script from "./FileSelect.vue?vue&type=script&lang=js"
export * from "./FileSelect.vue?vue&type=script&lang=js"
import style0 from "./FileSelect.vue?vue&type=style&index=0&id=04bee9e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bee9e4",
  null
  
)

export default component.exports